import React from "react";
import { FormSection, Field } from "redux-form";

import  {
	Card,
	ProgressIndicator,
	ReduxControls
} from "rhombus-react";

import { SOCIAL_AD_TYPES } from "utils/constants";
import { useErrorBanner } from "social/utils";

import { isDynamic } from "social/DynamicCreativeToggle";
import { assetType } from "social/BuildMethodRadio";
import CardContent from "social/carousel/CardContent";

import PinterestCarouselCardForm, { PINTEREST_CAROUSEL_FIELDS } from "social/carousel/PinterestCarouselCardForm";
import { CREATIVE_NAME_MAX_LENGTH } from "widgets/forms/validators/Creatives";
import { PINTEREST_IMAGE_CONSTRAINTS } from "social/validators/pinterest";
import DynamicInput from "../DynamicInput";

const {
	MAX_LENGTH_ALT_TEXT,
} = PINTEREST_IMAGE_CONSTRAINTS;

export default function PinterestCarousel(props){
	const {
		libraryId,
		navigationActions,
		isViewOnly,
		showPristineErrors,
		doVersionsExist,
	} = props;
	const adType = SOCIAL_AD_TYPES.PINTEREST_CAROUSEL;

	const showPristine = showPristineErrors || ["cardCount"]; // Always show at least the card count error

	const errorDisplay = useErrorBanner(adType, showPristine, PINTEREST_CAROUSEL_FIELDS);

	return (
		<FormSection name={adType}>
			<div className="carousel-modal-content progress-container">
				{errorDisplay}
				<ProgressIndicator isLoading={false} />
				<div className="form-container">
					<div className="fields">
						<Field {...isDynamic} />
						<Field {...assetType} />
					</div>
				</div>
				<Card
					className="carousel-main-content"
					header="Main Content"
					isCollapsable
					isVisible
				>
					<div className="form-container">
						<Field
							name = "name"
							label = "Creative Name"
							className = "full-width cypress-creative-name"
							placeholder = {isViewOnly ? "" : "Enter a creative name"}
							component = {ReduxControls.Input}
							charMax = {CREATIVE_NAME_MAX_LENGTH}
							showCharCount
							disabled = {isViewOnly}
							showPristineErrors = {showPristineErrors}
							required
						/>
						<Field
							name="altText"
							label="Alt Text"
							className="full-width"
							placeholder="Text for screen readers..."
							tip={{
								direction: "right",
								description: "Explain what people can see in the pin. This text will be read aloud by screen readers.",
								size: "xlarge",
							}}
							component={DynamicInput}
							defaultDynVarName="alt_text"
							charMax={MAX_LENGTH_ALT_TEXT}
							disabled={isViewOnly}
						/>
					</div>
				</Card>
				<CardContent
					libraryId={libraryId}
					adType={adType}
					isViewOnly={isViewOnly}
					showPristineErrors={showPristineErrors}
					navigationActions={navigationActions}
					doVersionsExist={doVersionsExist}
					CardForm={PinterestCarouselCardForm}
				/>
			</div>
		</FormSection>
	);
}

PinterestCarousel.displayName = "PinterestCarousel";
